<template>
  <b-modal
    class="wheel-modal"
    :active="showModalLivestream"
    has-modal-card
    full-screen
    @close="setShowModalLivestream(false);
    stopSpin();
    isSpin = false;
    offset=0;
    resetShowFarmers();
    setDoneFarmerShow(false);
    setItems([]);"
  >
    <div class="modal-card modal_card">
      <section class="modal-card-body modal_body" :style="{ 'background-image': 'url(' + this.background + ')' }">
        <div class="modal_left">
          <div class="modal_left_content">
            <img src="../../../../assets/title-image.png" alt />
            <div class="images">
              <img
                class="spin_img"
                :class="{wheelImage: isSpin}"
                :src="campaignOffline? campaignOffline.wheelImage : ''"
                alt
              />
              <img
                class="spin_img pinImage"
                :src="campaignOffline ? campaignOffline.pinImage : ''"
                alt
              />
            </div>

            <b-button
              class="btn_start"
              :disabled="isSpin"
              type="is-warning"
              @click="startSpin"
            >Bắt đầu quay</b-button>
            <b-field class="offset">
              <b-input v-model="offset" placeholder="Số đã quay"></b-input>
            </b-field>
          </div>
        </div>

        <div class="modal_right">
          <!-- <img class="img_lable" src="../../../../assets/artboard3.png" alt /> -->
          <img class="img_title" src="../../../../assets/artboard2.png" alt />
          <!-- <img class="img_logo" src="../../../../assets/logo.png" alt /> -->

          <div class="modal_right_content">
            <img class="bg" src="../../../../assets/artboard.png" alt />

            <div class="table" v-if="data.length>0">
              <div class="table_content">
                <table style="width: 100%">
                  <thead>
                    <tr>
                      <th>STT</th>
                      <th>Mã NV</th>
                      <th>Họ tên</th>
                      <th>Số điện thoại</th>
                      <th>Giải thưởng</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in data" :key="item._id">
                      <td class="table_red">{{item.serial}}</td>
                      <td class="table_nomal">{{item.code}}</td>
                      <td class="table_red">{{item.fullname}}</td>
                      <td class="table_nomal">{{item.phone | hidenPhone }}</td>
                      <td class="table_red">{{item.prizeName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="showFarmer_null" v-else>Chưa có danh sách giải</div>
          </div>
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  name: "ProductCampaignLivestreamModal",
  data() {
    return {
      isSpin: false,
      interval: null,
      offset: 0,
      background: ''
    };
  },
  mounted() {
    this.getSettings()
  },
  computed: {
    ...mapGetters({
      showModalLivestream: "productCampaign/showModalLivestream",
      campaignOffline: "productCampaign/campaignOffline",
      data: "farmerCampaign/items",
      count: "farmerCampaign/count",
      countIndex: "productCampaign/countIndex",
      doneShowFarmer: "productCampaign/doneShowFarmer"
    })
  },
  methods: {
    ...mapMutations({
      setShowModalLivestream: "productCampaign/setShowModalLivestream",
      resetShowFarmers: "productCampaign/resetShowFarmers",
      setDoneFarmerShow: "productCampaign/setDoneFarmerShow",
      setSpin: "productCampaign/setSpin",
      setQuery: "farmerCampaign/setQuery",
      setItems: "farmerCampaign/setItems"
    }),
    ...mapActions({
      // getFarmersOffline: "productCampaign/getFarmersOffline",
      getFarmersCampaign: "farmerCampaign/filter",
      changeOffset: "farmerCampaign/changeOffset"
    }),
    async getSettings() {
      this.$store.dispatch('setting/getList', { local: false, query: { 
        limit: 0,
        filter: {
          code: { $in: ['OFFLINE_WHEEL_BACKGROUND'] }
        },
      } }).then(res => {
        let backgroundSetting = res.find(x => x.code == 'OFFLINE_WHEEL_BACKGROUND')
        this.background = backgroundSetting?backgroundSetting.value:"../../../../assets/bg-campaign.png";
        console.log(this.background)
    })
    },
    async startSpin() {
      this.setQuery({
        limit: 20,
        order: { serial: 1 },
        filter: { productCampaign: this.campaignOffline._id }
      });
      this.isSpin = true;
      this.interval = setInterval(() => {
        if (this.offset > this.count) {
          this.stopSpin();
          this.finallSpin();
          return;
        }
        this.changeOffset(this.offset);
        this.offset = +this.offset + 20;
      }, 3000);
    },
    finallSpin() {
      this.$buefy.toast.open({
        message: "Kết thúc vòng quay!",
        type: "is-success",
        position: "is-top-right"
      });
    },
    stopSpin() {
      this.isSpin = false;
      clearInterval(this.interval);
    }
  },
  created() {}
};
</script>

<style lang="scss">
  .wheel-modal {
    .modal-close {
      background: rgba(0, 0, 0, 0.4);
      &:hover {
      background: rgba(0, 0, 0, 0.6);
      }
    }
  }
</style>
<style lang="scss" scoped>
.showFarmer_null {
  position: relative;
  z-index: 99;
  color: $primary;
  font-size: 25px;
}
.showFarmer_done {
  position: relative;
  z-index: 99;
  color: $primary;
  font-size: 25px;
  bottom: 5%;
}
.modal-card-body {
  background-color: white;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.modal_card {
  width: 100%;
  height: 100%;
  .modal_body {
    width: 100%;
    height: 100%;
    display: flex;
    .modal_left {
      width: 40%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      img {
        width: 60%;
        margin: 0 auto;
      }
      .modal_left_content {
        display: flex;
        flex-direction: column;
        .images {
          width: 100%;
          position: relative;
          height: 60vh;
          .spin_img {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            &.wheelImage {
              animation: spin 1.5s linear infinite;
            }
          }
        }
        .btn_start {
          text-transform: uppercase;
          font-weight: 700;
          font-size: 20px;
          margin: 0 auto;
        }
      }
    }
    .modal_right {
      width: 60%;
      background-color: transparent;
      position: relative;
      .img_lable {
        position: absolute;
        left: 50%;
        top: 0%;
        transform: translateX(-50%);
        z-index: 5;
        width: 60%;
      }
      .img_title {
        position: absolute;
        top: 18%;
        // top: 20%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 5;
        width: 40%;
      }
      .img_logo {
        position: absolute;
        top: 16%;
        left: 10%;
        transform: translateX(-50%);
        z-index: 5;
        width: 10%;
      }
      .modal_right_content {
        height: 88%;
        position: relative;
        top: 12%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .bg {
          position: absolute;
          width: 100%;
          height: 100%;
        }

        .table {
          width: 100%;
          height: 100%;
          position: relative;
          background: transparent;
          font-size: 12px;
          .table_red {
            color: red;
            font-weight: bold;
          }
          .table_nomal {
            color: $primary;
            font-weight: bold;
          }

          .table_content {
            position: absolute;
            overflow: auto;
            width: 100%;
            height: 100%;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            padding: 20px;
            padding-top: 15%;
          }
        }
      }
    }
  }
}
.offset {
  width: 20%;
  margin: 0 auto;
  margin-top: 10px;
}
@keyframes spin {
  100% {
    transform: translateX(-50%) translateY(-50%) rotate(360deg);
  }
}
</style>